import { connect } from 'react-redux'

function mapStateToProps (state) {
  return {
    comments: state.overview?.comments || [],
  }
}

function mapDispatchToProps (dispatch) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
